import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ModelView } from './features/ModelView/ModelView';
import { SimulationView } from './features/ModelView/SimulationView/SimulationView';
import { SimulationParametersView } from './features/ModelView/SimulationView/SimulationParametersView';
import { RouteErrorBoundary } from './components/RouteErrorBoundary/RouteErrorBoundary';
import { About } from './pages/About/About';
import { AddModel } from './pages/AddModel/AddModel';
import { Api } from './pages/Api/Api';
import { Browse } from './pages/Browse/Browse';
import { Home } from './pages/Home/Home';
import { InvalidURL } from './pages/InvalidURL/InvalidURL';
import { Layout } from './pages/Layout';
import { ComputeObject } from './pages/ModelPages/Compute/ComputeObject/ComputeObject';
import { ComputeVariogram } from './pages/ModelPages/Compute/ComputeVariogram/ComputeVariogram';
import { Model } from './pages/ModelPages/Model/Model';
import { ObjectResult } from './pages/ModelPages/Results/ObjectResult/ObjectResult';
import { VariogramResults } from './pages/ModelPages/Results/VariogramResults/VariogramResults';
import { Simulation } from './pages/Simulation/Simulation';
import { ScenarioBuilder } from './pages/ScenarioBuilder/ScenarioBuilder';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'models',
        element: <Browse />,
      },
      {
        path: 'api',
        element: <Api />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'add-model',
        element: <AddModel />,
      },
      {
        path: 'simulations/:simulationId',
        element: <Simulation />,
      },
      {
        path: 'scenario-builder',
        element: <ScenarioBuilder />,
      },
      {
        path: 'models/:modelId/',
        element: <Model />,
        children: [
          {
            index: true,
            element: <ModelView />,
          },
          {
            path: 'compute/variogram',
            element: <ComputeVariogram />,
          },
          {
            path: 'compute/object',
            element: <ComputeObject />,
          },
          {
            path: 'results/variogram',
            element: <VariogramResults />,
          },
          {
            path: 'results/object',
            element: <ObjectResult />,
          },
          {
            path: 'simulation/results',
            element: <SimulationView />,
          },
          {
            path: 'simulation/parameters',
            element: <SimulationParametersView />,
          },
        ],
      },
    ],
  },

  {
    path: '*',
    element: <InvalidURL />,
  },
]);

export { router };
